import React from 'react';
import PropTypes from 'prop-types';
import RepeatableFieldView from './FieldViewTypes/RepeatableFieldView';
import TextFieldView from './FieldViewTypes/TextFieldView';
import SelectFieldView from './FieldViewTypes/SelectFieldView';
import DateFieldView from './FieldViewTypes/DateFieldView';
import FieldArrayView from './FieldViewTypes/FieldArrayView';
import LanguageFieldView from './FieldViewTypes/LanguageFieldView';
import CheckboxFieldView from './FieldViewTypes/CheckboxFieldView';
import LocationFieldView from './FieldViewTypes/LocationFieldView';
import BarcodeFieldView from './FieldViewTypes/BarcodeFieldView';

const isRepeatableExpFieldsTypes = [
  'fieldArray',
  'languageField',
  'customTitle',
  'barcodeField',
  'instanceField',
];

const fieldViewComponents = {
  text: TextFieldView,
  textArea: TextFieldView,
  select: SelectFieldView,
  date: DateFieldView,
  checkbox: CheckboxFieldView,
  fieldArray: FieldArrayView,
  toggleButton: () => <div />,
  locationField: LocationFieldView,
  languageField: LanguageFieldView,
  barcodeField: BarcodeFieldView,
};

const propTypes = {
  fieldValues: PropTypes.object,
  index: PropTypes.number,
  locale: PropTypes.string,
  data: PropTypes.object,
  controlledVocab: PropTypes.object,
};

function FieldViewGenerator({
  fieldValues,
  index,
  locale,
  data,
  controlledVocab,
}) {
  const { isRepeatable, type } = fieldValues;
  const FieldComponent = fieldViewComponents[fieldValues.type];

  if (isRepeatable && !isRepeatableExpFieldsTypes.includes(type)) {
    return (
      <RepeatableFieldView
        index={index}
        fieldValues={fieldValues}
        locale={locale}
        data={data}
        controlledVocab={controlledVocab}
      />
    );
  }

  return (
    <FieldComponent
      index={index}
      fieldValues={fieldValues}
      locale={locale}
      data={data}
      controlledVocab={controlledVocab}
    />
  );
}

FieldViewGenerator.propTypes = propTypes;

export default FieldViewGenerator;
